import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { DemandSettingsEPG } from '~/src/dash/components/demand_settings/demand-settings-epg';
import { DemandSettingsMagniteCTV } from '~/src/dash/components/demand_settings/magnitectv/demand_settings_magnitectv';
import { DemandSettingsSamsungSSP } from '~/src/dash/components/demand_settings/samsungssp/demand_settings_samsungssp';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModelSmallButton } from '~/src/dash/components/model-medium-button';
import { Row, Rows, Text, usePublicaTranslation } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { genBiddersMenuList } from '~/src/dash/utils/header-bidder-adapters';
import {
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';
import { GetSelectedValuesFromMenuListSingle } from '~/src/dash/utils/menu_list_utils';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { DemandSources } from '~/src/dash/globals/demand-sources';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

const _IDemandSettingsView = (props: IProps) => {
  const { t } = usePublicaTranslation();
  const [demandSource, setDemandSource] = useState<IMenuList>({});

  let saveChild = () => void 0;
  let saveChild2 = () => void 0;

  useEffect(() => {
    const _demandSource = genBiddersMenuList(
      [],
      props.session.publisher,
      [],
      '',
      hasRoleSuperUser(props.user.user),
    );
    setDemandSource(_demandSource);
  }, []);

  const generateViewFromDemandSource = (demandSource: string) => {
    switch (demandSource) {
      case DemandSources.magnitectv:
        return (
          <DemandSettingsMagniteCTV
            setSaveFunc={(newSaveChild: () => undefined) => {
              saveChild = newSaveChild;
            }}
          />
        );
      case DemandSources.samsungssp:
        return (
          <DemandSettingsSamsungSSP
            setSaveFunc={(newSaveChild: () => undefined) => {
              saveChild = newSaveChild;
            }}
          />
        );
    }
    return <></>;
  };

  const generateEPGOverrideFromDemandSource = (demandSource: string) => {
    if (demandSource.length === 0) {
      return (
        <p style={{ marginTop: '10px', marginBottom: '10px' }}>
          {t('BiddersTextChooseDemandSource')}
        </p>
      );
    }
    return (
      <DemandSettingsEPG
        demandSource={demandSource}
        setSaveFunc={(newSaveChild: () => undefined) => {
          saveChild2 = newSaveChild;
        }}
      />
    );
  };

  const handleSave = () => {
    saveChild();
    saveChild2();
  };

  return (
    <Rows>
      <Row>
        <Text tKey='BiddersTextSetParameters' />
      </Row>
      <Row>
        <Grid container direction='row' alignItems='center' style={{ marginBottom: '10px' }}>
          <Grid item>
            <MaterialSearchDropdownMulti
              menuTitle={t('DemandSource')}
              list={demandSource}
              onChange={setDemandSource}
              enableMultiSelect={false}
              width='150px'
            />
          </Grid>
          <Grid item style={{ marginLeft: '55px' }}>
            <ModelSmallButton variant='contained' color='primary' onClick={() => handleSave()}>
              {t('Save')}
            </ModelSmallButton>
          </Grid>
        </Grid>
      </Row>
      <Row>
        {generateEPGOverrideFromDemandSource(
          GetSelectedValuesFromMenuListSingle(demandSource) || '',
        )}
      </Row>
      <Row>
        {generateViewFromDemandSource(GetSelectedValuesFromMenuListSingle(demandSource) || '')}
      </Row>
    </Rows>
  );
};

export const IDemandSettingsComponent = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      clampTableCell: {
        whiteSpace: 'nowrap',
        width: '1px',
      },
    }),
    router: true,
  },
  _IDemandSettingsView,
);
